'use client';

import Head from "next/head";
import {Fragment, useContext, useEffect, useMemo, useState} from "react";
import Breadcrumb from "@components/ui/breadcrumb";
import ShopGrid from "@components/shop/ShopGrid";
import {toCapitalize} from "@utils/toCapitalize";
import {FooterOne as Footer} from "@components/footer";
import {HeaderSix as Header} from "@components/header";
import {ProductsContext} from "@global/ProductsContext";
import {HomePagesNavData as navContent} from "@data/navbar";
import {ContentWrapperOne as ContentWrapper} from "@components/wrapper";
import {getProductsByCategory,} from "@utils/product";
import {Categories} from "src/graphql/query/categories";
import client from "src/apollo/apollo-client";

const PageProductCategory = ({category}) => {
    const {products} = useContext(ProductsContext);
    const [isMounted, setIsMounted] = useState(false);

    const categoryProducts = useMemo(() => {
        if (!products || !category) return [];
        return getProductsByCategory(products, category, -1);
    }, [products, category]);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return null;
    }

    const logo = "/assets/images/brand/nobg-logo.svg";


    return (
        <Fragment>
            <Head>
                <title>{category ? `${category} - San Marino` : "Categoría desconocida - San Marino"}</title>
            </Head>
            <Header
                logo={logo}
                navbar={true}
                navData={navContent}
                containerFluid={true}
                logoAlignment="left"
                navbarAlignment="left"
            />

            <ContentWrapper>
                <Breadcrumb/>
                <ShopGrid
                    sidebar={true}
                    categoryFilter={false}
                    subCategoryFilter={true}
                    sidebarPosition="left"
                    containerFluid={false}
                    products={categoryProducts}
                    pageTitle={toCapitalize(category)}
                    category={category}
                />
            </ContentWrapper>

            <Footer logo={logo} newsletter={true}/>
        </Fragment>
    );
};

export const getStaticProps = async ({params}) => {
    if (!params.slug) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            category: params.slug,
        },
    };
};

export const getStaticPaths = async () => {
    const {data: queryData} = await client.query({
        query: Categories,
    });

    return {
        paths: queryData.categories.data.map((category) => {
            return {
                params: {
                    slug: category.attributes.name,
                },
            };
        }),
        fallback: 'blocking'
    };
};

export default PageProductCategory;
